import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type MobileSidebarState = {
  opened: boolean;
  open: () => void;
  close: () => void;
};

export const useMobileSidebarStore = create<MobileSidebarState>()(
  immer((set) => ({
    opened: false,
    open: () => {
      set((state) => {
        state.opened = true;
      });
    },
    close: () => {
      set((state) => {
        state.opened = false;
      });
    },
  }))
);
